export interface BaseEventData {
  botId: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  pageUrl: string;
  timestamp: number;
}

interface GTMEvent extends BaseEventData {
  [key: string]: unknown;
}

const sendEvent = (eventName: string, eventData: GTMEvent, websiteLocation?: string) => {
  if (websiteLocation) {
    window.parent.postMessage({
      type: 'gtm-event',
      eventName: eventName,
      payload: eventData
    }, websiteLocation);
  }
};

export const trackAvatarLoad = (baseData: BaseEventData, websiteLocation?: string) => {
  sendEvent('aime_avatar_load', {...baseData}, websiteLocation);
};

export const trackBubbleLoad = (baseData: BaseEventData, websiteLocation?: string) => {
  sendEvent('aime_bubble_load', {...baseData}, websiteLocation);
};

export const trackChatOpen = (baseData: BaseEventData, websiteLocation?: string, source?: string) => {
  sendEvent('aime_chat_open', {...baseData, ...(source && { source })}, websiteLocation);
};

export const trackChatClose = (baseData: BaseEventData, websiteLocation?: string) => {
  sendEvent('aime_chat_close', {...baseData}, websiteLocation);
};

export const trackChatClear = (baseData: BaseEventData, websiteLocation?: string) => {
  sendEvent('aime_chat_clear', {...baseData}, websiteLocation);
};

export const trackMessageSent = (baseData: BaseEventData, userMessage: string, characterCount: number, websiteLocation?: string) => {
  sendEvent('aime_message_sent', {...baseData, userMessage, characterCount}, websiteLocation);
};

export const trackBubbleMessageSent = (baseData: BaseEventData, userMessage: string, characterCount: number, websiteLocation?: string) => {
  sendEvent('aime_bubble_message_sent', {...baseData, userMessage, characterCount}, websiteLocation);
};

export const trackQRClick = (baseData: BaseEventData, qrLabel: string, websiteLocation?: string) => {
  sendEvent('aime_qr_click', {...baseData, qrLabel}, websiteLocation);
};

export const trackBubbleQRClick = (baseData: BaseEventData, qrLabel: string, websiteLocation?: string) => {
  sendEvent('aime_bubble_qr_click', {...baseData, qrLabel}, websiteLocation);
};

// Vehicle viewed
export const trackVehicleViewed = (baseData: BaseEventData, vehicleId: string, websiteLocation?: string) => {
  sendEvent('aime_vehicle_viewed', {...baseData, vin: vehicleId}, websiteLocation);
};


export const trackLinkOut = (baseData: BaseEventData, linkUrl: string, websiteLocation?: string) => {
  sendEvent('aime_link_out', {...baseData, linkUrl}, websiteLocation);
};
